import React from "react";

const PriceSummary = ({
  subtotal = 0,
  discount = 0,
  tax = 0,
  shipping = 0,
  handling = 0,
  totalAmount = 0,
  state = "",
  title = "Price Summary",
}) => {
  const isGujarat = state.toLowerCase() === "gujarat";

  return (
    <div className="card rounded-3 shadow-sm ">
      <div className="card-body">
        <div className="mb-2 d-flex justify-content-between">
          <span>Subtotal</span>
          <span>{subtotal}</span>
        </div>

        <div className="mb-2 d-flex justify-content-between">
          <span>Discount</span>
          <span>{discount}</span>
        </div>

        {isGujarat ? (
          <>
            <div className="mb-2 d-flex justify-content-between">
              <span>CGST</span>
              <span>{(tax / 2).toFixed(2)}</span>
            </div>
            <div className="mb-2 d-flex justify-content-between">
              <span>SGST</span>
              <span>{(tax / 2)?.toFixed(2)}</span>
            </div>
          </>
        ) : (
          <div className="mb-2 d-flex justify-content-between">
            <span>IGST</span>
            <span>{tax}</span>
          </div>
        )}

        {/* <div className="mb-2 d-flex justify-content-between">
          <span>Shipping</span>
          <span>{shipping}</span>
        </div> */}

        <div className="mb-2 d-flex justify-content-between">
          <span>Handling Charge</span>
          <span>{handling?.toFixed(2) || 0}</span>
        </div>

   <hr className="my-3 border-2 border-dark" />
        <div className="d-flex justify-content-between" style={{fontWeight:"bold"}}>
          <span>Grand Total</span>
          <span>{totalAmount}</span>
        </div>
      </div>
    </div>
  );
};

export default PriceSummary;
